import _ from 'lodash';
import React from 'react';

import {
  FormModal,
  TransferList
} from 'modules';

import { Button } from '@mui/material';
import { errorUtil } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export interface IProps {
  storeId: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery();
  const [
    applyListingManagementStrategyTemplateGroups
  ] = dataService.useApplyListingManagementStrategyTemplateGroups(props.storeId);
  const transferListState = TransferList.useTransferListState();



  const handleClick = React.useCallback(
    async () => {
      const selectedTemplateIds = _.keys(_.pickBy(transferListState.id2IsSelected));
      if (_.isEmpty(selectedTemplateIds)) {
        window.alert("Select at least 1 template");

      } else if (window.confirm(`Are you sure you want to apply this template containing ${selectedTemplateIds.length} items?`)) {
        errorUtil.errorWrap(async () => {
          props.onClose();
          await applyListingManagementStrategyTemplateGroups(selectedTemplateIds);
        });
      }
    },
    [
      applyListingManagementStrategyTemplateGroups,
      props,
      transferListState.id2IsSelected
    ]
  );



  return (
    <FormModal.FC
      isDoubleWide
      title="Select Template"
      onClose={props.onClose}
      isLoading={queryTuple.loading}
      fnGenElAcceptButton={args => (
        <Button
          {...args}
          variant="contained"
          onClick={handleClick}>
          Apply Templates
        </Button>
      )}>
      <TransferList.FC
        {...transferListState}
        allItems={queryTuple.data.templates}
        loading={queryTuple.loading} />
    </FormModal.FC>
  );
};
